








import { Component, Vue, Prop } from "vue-property-decorator";
import { Getter } from "vuex-class";
import { LanguageDto, UserDto, MetadataConfiguration } from "@/server/app.dtos";
import { UsersService } from "@/services/api/users.service";
import { GetUserMetadataDtoQuery } from "@/server/app.queries";

@Component
export default class UserDetailMetadataPage extends Vue {
  @Prop() user!: UserDto;
  @Getter("currentLanguage") currentLanguage!: LanguageDto;
  usersService: UsersService = new UsersService();
  metadata: MetadataConfiguration | null = null;

  async created() {
    await this.LoadRelatedData();
  }

  async LoadRelatedData() {
    // Load Metadata
    const metadataQuery = new GetUserMetadataDtoQuery();
    metadataQuery.idUser = this.user.idUser;
    metadataQuery.idLanguage = this.currentLanguage.idLanguage;
    await this.usersService
      .GetMetadata(metadataQuery)
      .then((response: MetadataConfiguration) => (this.metadata = response));
  }
}
